@if (galleryPermissions().can_edit || filteredAssets()?.length) {
  <input
    type="file"
    id="{{ uploadIdPrefix }}asset-upload"
    #upload
    class="hidden-input"
    (change)="uploadAssetEvent($event.target)"
    accept="*"
    multiple
  />
  <app-drop
    (onFileDrop)="uploadAssets($event)"
    (onFileUrlDrop)="uploadAssets($event)"
    [hoverStyle]="'white'"
    [disable]="!galleryPermissions().can_edit"
    [darkBackground]="darkBackground()"
    [default]="sectionIndex() === 0"
  >
    <app-section-container
      #sectionContainer
      [index]="sectionIndex()"
      [gallery]="gallery()"
      [section]="section()"
      [sections]="sections()"
      [galleryPermissions]="galleryPermissions()"
      [darkBackground]="darkBackground()"
      [outsideActions]="true"
      [insideActions]="true"
      [noMaxWidth]="true"
      [theme]="theme()"
      sectionContentInnerPosition="relative"
      (addSection)="addSection.emit($event)"
    >
      @if (isDesktop()) {
        <ng-container sectionActionsOutside>
          <div class="spaced-button-group-item">
            <app-context-menu
              [options]="{ width: '240px', noSpacing: true }"
              [position]="'right-out'"
              [verticalPosition]="'auto-in'"
              #sourceMenu
              contextHoverIdentifier="section-{{ section().id }}"
            >
              <button
                appButton
                name="select-source"
                location="assets-section"
                [iconButton]="true"
                height="1"
                shape="round"
                color="simple"
                appTooltip="Upload Media"
                toolTipOrigin="left"
                contextButton
              >
                <app-svg src="/assets/icons/upload.svg"></app-svg>
              </button>

              <div contextContent class="button-menu">
                <app-upload-source-menu
                  [uploadIdPrefix]="uploadIdPrefix"
                  [sectionId]="section().id"
                  (onClose)="sourceMenu.close()"
                  (onUpload)="uploadAssets($event)"
                ></app-upload-source-menu>
              </div>
            </app-context-menu>
          </div>
        </ng-container>
      }

      <ng-container sectionActionsInside>
        @if (isDesktop()) {
          <div class="spaced-button-group-item">
            <app-context-menu
              [options]="{ width: '320px', noSpacing: true }"
              [position]="'right-out'"
              [verticalPosition]="'auto-in'"
              #menu
              contextHoverIdentifier="section-{{ section().id }}"
            >
              <button
                appButton
                name="settings"
                location="assets-section"
                [iconButton]="true"
                height="1"
                shape="round"
                contextButton
                appTooltip="Section Settings"
                toolTipOrigin="left"
                color="simple"
              >
                <app-svg src="/assets/icons/mixer.svg"></app-svg>
              </button>
              <div contextContent>
                @if (menu.isOpen()) {
                  <app-assets-section-menu [section]="section()" [gallery]="gallery()" [theme]="theme()">
                  </app-assets-section-menu>
                }
              </div>
            </app-context-menu>
            <app-context-menu
              [options]="{ width: '320px' }"
              [position]="'right-out'"
              [verticalPosition]="'auto-in'"
              #sortingMenu
              contextHoverIdentifier="section-{{ section().id }}"
            >
              <button
                appButton
                name="sorting"
                location="assets-section"
                [iconButton]="true"
                height="1"
                shape="round"
                contextButton
                appTooltip="Update Order"
                toolTipOrigin="left"
                color="simple"
              >
                <app-svg src="/assets/icons/arrow-sorting.svg"></app-svg>
              </button>
              <div contextContent class="sorting-menu">
                <h3 class="menu-list-title">ASSET ORDER</h3>
                @if (sortingMenu.isOpen()) {
                  @for (sort of sortings; track sort) {
                    @if (
                      (sort !== 'position' || section().sorting === 'position') &&
                      (sort !== 'capture_time' ||
                        assetsContainCaptureTime() ||
                        section().sorting.endsWith('capture_time'))
                    ) {
                      <app-sorting-button
                        [name]="'sorting-' + sort"
                        location="assets-section"
                        [allowFlip]="sort !== 'position' && !sort.endsWith('id')"
                        [allowRandom]="sort.endsWith('id')"
                        [active]="section().sorting.endsWith(sort)"
                        [flipped]="section().sorting.startsWith('-')"
                        [randomized]="section().sorting.startsWith('-')"
                        (activeChanged)="changeAssetSorting(sort)"
                        (flippedChanged)="flipSorting()"
                        (randomChanged)="flipSorting()"
                      >
                        @if (sort === 'position') {
                          <span>Manual</span>
                        } @else if (sort === 'name') {
                          <span>Filename A-Z</span>
                        } @else if (sort === 'created_at') {
                          <span>Uploaded</span>
                        } @else if (sort === 'capture_time') {
                          <span>Capture Time</span>
                        } @else if (sort === 'id') {
                          <span>Random</span>
                        }
                      </app-sorting-button>
                    }
                  }
                }
              </div>
            </app-context-menu>
          </div>
        } @else {
          <app-context-menu
            [options]="{ width: '320px', noSpacing: true }"
            #menu
            contextHoverIdentifier="section-{{ section().id }}"
          >
            <button
              appButton
              name="settings"
              location="assets-section"
              color="simple"
              height="1"
              fullWidth="true"
              [hasIcon]="true"
              contextButton
            >
              <app-svg src="/assets/icons/mixer.svg"></app-svg>
              <span>Options</span>
            </button>
            <div contextContent>
              @if (menu.isOpen()) {
                <app-assets-section-menu [section]="section()" [gallery]="gallery()" [theme]="theme()">
                </app-assets-section-menu>
              }
            </div>
          </app-context-menu>
          <app-context-menu
            [options]="{ width: '320px' }"
            #sortingMenu
            contextHoverIdentifier="section-{{ section().id }}"
          >
            <button
              appButton
              name="sorting"
              location="assets-section"
              height="1"
              fullWidth="true"
              [hasIcon]="true"
              contextButton
              color="simple"
            >
              <app-svg src="/assets/icons/arrow-sorting.svg"></app-svg>
              <span>Order</span>
            </button>
            <div contextContent class="sorting-menu">
              <h3 class="menu-list-title">ASSET ORDER</h3>
              @if (sortingMenu.isOpen()) {
                @for (sort of sortings; track sort) {
                  @if (
                    (sort !== 'position' || section().sorting === 'position') &&
                    (sort !== 'capture_time' ||
                      assetsContainCaptureTime() ||
                      section().sorting.endsWith('capture_time'))
                  ) {
                    <app-sorting-button
                      [name]="'sorting-' + sort"
                      location="assets-section"
                      [allowFlip]="sort !== 'position' && !sort.endsWith('id')"
                      [allowRandom]="sort.endsWith('id')"
                      [active]="section().sorting.endsWith(sort)"
                      [flipped]="section().sorting.startsWith('-')"
                      [randomized]="section().sorting.startsWith('-')"
                      (activeChanged)="changeAssetSorting(sort)"
                      (flippedChanged)="flipSorting()"
                      (randomChanged)="flipSorting()"
                    >
                      @if (sort === 'position') {
                        <span>Manual</span>
                      } @else if (sort === 'name') {
                        <span>Filename A-Z</span>
                      } @else if (sort === 'created_at') {
                        <span>Uploaded</span>
                      } @else if (sort === 'capture_time') {
                        <span>Capture Time</span>
                      } @else if (sort === 'id') {
                        <span>Random</span>
                      }
                    </app-sorting-button>
                  }
                }
              }
            </div>
          </app-context-menu>
        }
      </ng-container>
      <ng-container sectionContent>
        <div #sectionContent [class.dark]="darkBackground()">
          @if (filteredAssets() && !filteredAssets().length && galleryPermissions().can_edit) {
            <div class="page no-assets-page" appDragItem type="section" [id]="section().id">
              <div class="no-assets-fake-assets">
                <div class="fake-asset-column">
                  <div class="no-asset-fake-asset"></div>
                  <div class="no-asset-fake-asset"></div>
                  <div class="no-asset-fake-asset"></div>
                </div>
                <div class="fake-asset-column">
                  <div class="no-asset-fake-asset short"></div>
                  <div class="no-asset-fake-asset long"></div>
                  <div class="no-asset-fake-asset"></div>
                </div>
                <div class="fake-asset-column">
                  <div class="no-asset-fake-asset long"></div>
                  <div class="no-asset-fake-asset"></div>
                  <div class="no-asset-fake-asset"></div>
                </div>
                <div class="fake-asset-column">
                  <div class="no-asset-fake-asset short"></div>
                  <div class="no-asset-fake-asset short"></div>
                  <div class="no-asset-fake-asset"></div>
                </div>
              </div>
              <div class="no-gallery-assets">
                <div class="halo"></div>
                <label for="{{ uploadIdPrefix }}asset-upload">
                  <img
                    [attr.data-picflow-hide]="true"
                    src="/assets/icons/special/image-stack-upload-{{ darkBackground() ? 'light' : 'dark' }}.svg"
                    class="upload-icon"
                    alt=""
                  />
                </label>
                @if (isDesktop()) {
                  <h2>Upload Media</h2>
                  <div class="drop-assets-text-with-button">
                    <span>Drop or</span>
                    <app-context-menu
                      [options]="{ width: '240px', noSpacing: true }"
                      #sourceMenu
                      contextHoverIdentifier="section-{{ section().id }}"
                    >
                      <button
                        appButton
                        name="select-source"
                        location="assets-section"
                        color="simple-primary-opacity"
                        height="0"
                        spacing="1"
                        shape="small"
                        contextButton
                      >
                        Select Source
                      </button>

                      <div contextContent class="button-menu">
                        <app-upload-source-menu
                          [uploadIdPrefix]="uploadIdPrefix"
                          [sectionId]="section().id"
                          (onClose)="sourceMenu.close()"
                          (onUpload)="uploadAssets($event)"
                        ></app-upload-source-menu>
                      </div>
                    </app-context-menu>
                  </div>
                } @else {
                  <div class="drop-assets-text-with-button">
                    <label
                      appButton
                      name="select-assets"
                      location="assets-section"
                      weight="bold"
                      color="primary"
                      shape="round"
                      for="{{ uploadIdPrefix }}asset-upload"
                      >Upload Media</label
                    >
                  </div>
                }
              </div>
            </div>
          }
          @if (!filteredAssets()) {
            <div class="loading-page page"></div>
          } @else if (filteredAssets().length) {
            <div
              class="gallery-assets-container"
              [class.no-animation]="noGalleryAnimation()"
              [style.maxWidth]="sectionWidth() + 'px'"
              [style.--spacing.px]="section()?.spacing ?? theme()?.section.spacing"
              [class.debug]="debugMode()"
              #assetGallery
            >
              <app-infinite-scroll
                [resultCount]="assets().length"
                [lastResultId]="lastAsset()?.id"
                [allResultsLoaded]="allAssetsLoaded()"
                [offset]="300"
                [disabled]="processingNewAssets()"
                (fetchMore)="fetchMoreAssets$.next()"
              >
                <div
                  class="gallery-assets {{ section().grid_layout ?? theme().section.grid_layout }}"
                  [class.no-animation]="noGalleryAnimation()"
                  [class.drag-hover-drop]="dontReactToHover() && dragHovering()?.context === section().id"
                  [class.applying-sorting]="applyingSorting()"
                >
                  @for (asset of filteredAssetsAndUploads(); track asset.id) {
                    @let pos = assetPositions()[$index];
                    @if (pos) {
                      <div
                        class="gallery-asset"
                        [class.rounded]="section().rounded_corners ?? theme().section.rounded_corners"
                        [class.with-bg]="withBg(asset)"
                        [class.rounded]="section().rounded_corners ?? theme().section.rounded_corners"
                        (contextmenu)="assetRightClick(asset, $event)"
                        [attr.id]="'asset-' + asset.id"
                        data-transition-to-page="true"
                        (mouseenter)="isDesktop() && hoverAssetId.set(asset.id)"
                        (mouseleave)="isDesktop() && hoverAssetId.set(undefined)"
                        appInferredHover="asset-{{ asset.id }}"
                        [style.width]="pos.dimensions.width + 'px'"
                        [style.height]="pos.dimensions.height + 'px'"
                        [style.left]="pos.dimensions.x + 'px'"
                        [style.top]="pos.dimensions.y + 'px'"
                        inViewNew
                        (onInView)="setInView(asset.id, true)"
                        (onOutOfView)="setInView(asset.id, false)"
                        appDragItem
                        type="asset"
                        [id]="asset.id"
                        [context]="section().id"
                        [extra]="pos.dimensions.height / pos.dimensions.width"
                        [class.dragging]="draggingAssetId() === asset.id"
                        [class.drag-hover-move-before]="dragHoverMoveBeforeAsset()?.id === asset.id"
                        [class.drag-hover-move-after]="dragHoverMoveAfterAsset()?.id === asset.id"
                        appTransitionPreventor
                      >
                        @if (inView().get(asset.id)) {
                          @if (!!draggingAssetId()) {
                            <div
                              class="bounds"
                              [style.left.px]="pos.bounds.x - pos.dimensions.x"
                              [style.top.px]="pos.bounds.y - pos.dimensions.y"
                              [style.width.px]="pos.bounds.width"
                              [style.height.px]="pos.bounds.height"
                            >
                              @let right = pos.bounds.x + pos.bounds.width === sectionWidth();
                              @let left = !pos.bounds.x;
                              @let top = !pos.bounds.y;
                              @let bottom =
                                section().grid_layout === 'columns'
                                  ? (pos.bounds | isVeryBottom: $index : assetPositions())
                                  : pos.bounds.y + pos.bounds.height === sectionHeight();
                              <div
                                class="drag-drop-location"
                                [class.top]="top"
                                [class.left]="left"
                                [class.right]="right"
                                [class.bottom]="bottom"
                              ></div>
                            </div>
                          }
                        }

                        @let inferredHover =
                          contextService.openContextMenus$ | async | inferredContextOpen: 'asset-' + asset.id;
                        @let hovering = hoverAssetId() === asset.id;
                        @if (inView().get(asset.id)) {
                          @if (['completed', 'failed'].includes(asset.version_data.status)) {
                            @if ((hovering || inferredHover) && !draggingItem()) {
                              @if (galleryPermissions().can_edit) {
                                <div class="asset-menu-container" [@assetButton]>
                                  <app-context-menu
                                    [options]="{ noSpacing: true, width: '240px' }"
                                    #menu
                                    contextHoverIdentifier="asset-{{ asset.id }}"
                                  >
                                    <button
                                      appButton
                                      name="asset-context"
                                      location="assets-section"
                                      [iconButton]="true"
                                      color="dark-blur"
                                      shape="round"
                                      height="-1"
                                      contextButton
                                      #button
                                    >
                                      <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
                                    </button>
                                    <div contextContent>
                                      @if (menu.isOpen()) {
                                        <app-asset-context-menu
                                          [asset]="asset"
                                          [galleryPermissions]="galleryPermissions()"
                                          [gallery]="gallery()"
                                          [autoplayShown]="true"
                                          (onClose)="menu.close()"
                                          (onCoverChange)="onCoverChange.emit()"
                                          (openShare)="openShareDialog(asset)"
                                          #assetContextMenu
                                        >
                                        </app-asset-context-menu>
                                      }
                                    </div>
                                  </app-context-menu>
                                </div>
                              } @else if (asset | canDownloadAsset: gallery() : galleryPermissions()) {
                                <app-asset-download-button
                                  [@assetButton]
                                  location="assets-section"
                                  [galleryPermissions]="galleryPermissions()"
                                  [asset]="asset"
                                  [gallery]="gallery()"
                                  (click)="downloadClick($event)"
                                >
                                  <button
                                    appButton
                                    name="download"
                                    location="assets-section"
                                    [iconButton]="true"
                                    color="dark-blur"
                                    shape="round"
                                    height="-1"
                                  >
                                    <app-svg src="/assets/icons/download.svg"></app-svg>
                                  </button>
                                </app-asset-download-button>
                              }
                            }
                          }
                        }
                        <a
                          [routerLink]="asset.id"
                          [queryParams]="assetQueryParams()"
                          class="asset-link"
                          draggable="false"
                          [preserveFragment]="true"
                        >
                          <app-layout-asset
                            [asset]="asset"
                            [preview]="asset['upload']?.previewSrc"
                            [gallery]="gallery()"
                            [roundedCorners]="section().rounded_corners ?? theme().section.rounded_corners"
                            [hovering]="(hovering || inferredHover) && !draggingItem()"
                            [isDesktop]="isDesktop()"
                            [width]="pos.dimensions.width"
                            [height]="pos.dimensions.height"
                            [galleryPermissions]="galleryPermissions()"
                            [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions()"
                            [colorLabels]="colorLabels()"
                            [clientMode]="false"
                            [showFilename]="!showFilenames()"
                            [darkBackground]="darkBackground()"
                          ></app-layout-asset>
                        </a>
                        @if (showFilenames()) {
                          <div class="asset-name" drag-ignore>
                            {{ asset.name }}
                          </div>
                        }
                      </div>
                    }
                  }
                </div>
                <div class="gallery-assets-placeholder" [style.height.px]="sectionHeight()"></div>
              </app-infinite-scroll>
            </div>

            @if (!isDesktop() && galleryPermissions().can_edit) {
              <app-sticky
                [offsetBottom]="20"
                [paddingY]="0"
                [container]="sectionContainer?.sectionContentInner?.nativeElement"
                stickTo="bottom"
                [fullWidth]="true"
              >
                <label
                  appButton
                  for="{{ uploadIdPrefix }}asset-upload"
                  name="mobile-upload"
                  location="assets-section"
                  [hasIcon]="true"
                  color="hard-simple"
                  class="mobile-upload-button"
                  height="1"
                  weight="bold"
                  shape="round"
                  [center]="true"
                >
                  <app-svg src="/assets/icons/upload.svg" size="0"></app-svg>
                  <span>Upload</span>
                </label>
              </app-sticky>
            }
          }
        </div>
      </ng-container>
    </app-section-container>
  </app-drop>
}
